export default __webpack_public_path__ + "static/media/banner.eda314b3.png";